var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "#363870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77265 8.68863C6.7809 8.60729 6.76987 8.52515 6.74046 8.44887C6.71105 8.37259 6.66407 8.30431 6.60335 8.24957L5.34882 6.73848V6.5127H9.24413L12.255 13.1158L14.902 6.5127H18.6153V6.73848L17.5427 7.76684C17.4974 7.80142 17.4623 7.84773 17.4413 7.90078C17.4203 7.95382 17.4142 8.01159 17.4236 8.06785V15.6242C17.4142 15.6804 17.4203 15.7382 17.4413 15.7913C17.4623 15.8443 17.4974 15.8906 17.5427 15.9252L18.5903 16.9536V17.1794H13.3213V16.9536L14.4065 15.9001C14.5131 15.7936 14.5131 15.7621 14.5131 15.5991V9.49121L11.4959 17.1542H11.0883L7.57561 9.49129V14.6271C7.56117 14.7336 7.57117 14.8421 7.60486 14.9442C7.63855 15.0464 7.69505 15.1395 7.77007 15.2165L9.1814 16.9285V17.1543H5.17944V16.9285L6.59085 15.2165C6.66526 15.1394 6.72049 15.0459 6.75208 14.9435C6.78368 14.8411 6.79075 14.7327 6.77272 14.6271L6.77265 8.68863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.5f3789745c61847b2d622d95bcb7d2d8.svg";
export { ForwardRef as ReactComponent };